import './button.scss';

import cn from 'classnames';
import React, { HTMLAttributes } from 'react';

interface IButtonProps extends HTMLAttributes<HTMLButtonElement> {
  children: React.ReactNode;
  onClick?: (e: React.MouseEvent<HTMLButtonElement>) => void;
  color?: 'primary' | 'secondary' | 'transparent' | 'error' | 'error-secondary' | 'error-bordered';
  disabled?: boolean;
  type?: 'submit' | 'button';
  size?: 'small' | 'big';
  nodeLeft?: React.ReactNode;
  nodeRight?: React.ReactNode;
  className?: string;
}

const Button = React.forwardRef<HTMLButtonElement, IButtonProps>(
  (
    {
      children,
      color = 'primary',
      type,
      disabled = false,
      onClick,
      size = 'big',
      nodeLeft,
      nodeRight,
      className,
      ...rest
    },
    ref,
  ) => {
    const handleClick = (e: React.MouseEvent<HTMLButtonElement>): void => {
      if (onClick) {
        onClick(e);
      }
    };

    return (
      <button
        disabled={disabled}
        className={cn('mm-button', `mm-button-${color}`, `mm-button-${size}`, className)}
        type={type}
        onClick={handleClick}
        {...rest}
        ref={ref ?? undefined}
      >
        {nodeLeft && nodeLeft}
        {children}
        {nodeRight && nodeRight}
      </button>
    );
  },
);

export { Button };
